import { privacySections } from "@/content/trust";
import { site } from "@/content/site";
import { PageHero } from "@/components/ui/PageHero";
import { Section } from "@/components/ui/Section";

export default function PrivacyPage() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Privacy Policy"
        description={`This policy explains how Agentic Plus handles information through ${site.url}. It should be read with the service agreement governing your account.`}
      />

      <Section title="Privacy overview" tone="surface">
        <div className="max-w-4xl space-y-8">
          {privacySections.map((section) => (
            <article key={section.title}>
              <h2 className="text-2xl font-bold">{section.title}</h2>
              <p className="mt-3 leading-relaxed text-ink-soft">{section.description}</p>
            </article>
          ))}
        </div>
      </Section>

      <Section title="Contact about privacy" tone="paper">
        <div className="surface-card max-w-3xl p-7">
          <p className="text-ink-soft">
            For privacy questions, data export requests, deletion requests, or subprocessor details,
            contact{" "}
            <a className="font-bold underline" href={`mailto:${site.email}`}>
              {site.email}
            </a>
            .
          </p>
        </div>
      </Section>
    </>
  );
}
